<template>
    <div class="file">
        <div style="padding: 10px;overflow-y: scroll;margin-left: calc((100% - 1200px) / 2);width: 200px;"
            id="productscroll" :style="'height:' + height">
            <div class="ftext">
                <!-- cprimary  -->
                <div style="padding:10px 0px;" class="fbold file falign">
                    <!-- class="bprimary" -->
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="ftitle fbold"></div>AI产品
                </div>
                <div>
                    <div @click="getInfo(w, j)"
                        :class="[{ 'mindex': w.title == mindex }, { 'menu': mindex != w.title }]"
                        style="padding:10px 0px;padding-left: 13px;cursor: pointer;" v-for="(w, j) in menu">{{
                            w.title }}
                    </div>
                </div>
            </div>
        </div>
        <div style="flex: 1;-ms-overflow-style: none;scrollbar-width: none;">
            <div style="background: #f1f2f6;padding:40px 25px;width: 1000px;" id="productscrollb">
                <div v-if="data.title" class="file falign">
                    <div v-if="data.logo"><img style="height: 22px;margin-right: 5px;" :src="action + data.logo"></div>
                    <div style="font-size: 22px;" class="fbold">{{ data.title }}</div>
                </div>
                <div v-else class="file falign">
                    <div v-if="data.logo"><img :src="action + data.logo"></div>
                </div>
                <div style="margin-top: 26px;font-size: 15px;line-height: 25px;" v-show="data.text">
                    {{ data.text }}
                    <!--  -->
                </div>
                <div style="margin-top: 38px;padding-top: 38px; background: #fff;text-align: center;" v-if="data.img">
                    <div>
                        <div style="font-size: 28px;">{{ data.itetle }}</div>
                        <div v-show="data.itetleb" style="font-size: 28px;">{{ data.itetle }}</div>
                        <div v-show="data.itetlebc" style="font-size: 28px;">{{ data.itetle }}</div>
                        <div v-show="data.itext" style="font-size: 28px;font-weight: bold;color: #1e66d1;">
                            {{ data.itext }}</div>
                    </div>
                    <div style="padding: 20px 10px;"><img style="height: auto;width: 100%;" :src="data.img"></img></div>
                </div>
                <div style="background: #fff;margin-top: 25px;padding-bottom: 25px;">
                    <div style="padding: 38px;font-size: 28px;margin-left: 5px;text-align: center;">应用场景
                    </div>
                    <div class="file" style="flex-wrap: wrap">
                        <div style="width: 50%;padding:28px 30px 28px 0px;" v-for="x in data.card">
                            <div class="file">
                                <div style="height: 72px;margin-top: 6px;border-left: 2.5px solid #1e66d1;"
                                    class="bprimary">
                                </div>
                                <div v-if="index < 2" style="margin-left: 22px;width: 350px;">
                                    <div style="font-size: 18px;color: #1e66d1;" class="cprimary">{{ x.title }}</div>
                                    <div style="font-size: 14px;font-weight: bold;margin-top: 25px;">场景诉求：</div>
                                    <div class="ftext" style="color:#666;margin-top: 10px;line-height: 26px;">{{ x.text
                                        }}</div>
                                    <div style="margin-top: 30px;font-size: 14px;font-weight: bold;color: #ff6c00;">
                                        解决方案：</div>
                                    <div class="ftext" style="color:#666;margin-top: 10px;line-height: 26px;"><span
                                            style="color: #ff6c00;">√ </span><span style="font-weight: bold;" v-if="x.textbt">{{ x.textbt }}</span>{{ x.textb }}</div>
                                    <div class="ftext" style="color:#666;margin-top: 10px;line-height: 26px;"><span
                                            style="color: #ff6c00;">√ </span><span style="font-weight: bold;" v-if="x.textct">{{ x.textct }}</span>{{ x.textc }}</div>
                                </div>
                                <div v-else style="margin-left: 22px;width: 380px;">
                                    <div style="font-size: 18px;color: #1e66d1;" class="cprimary">{{ x.tttt }}</div>
                                    <div class="ftext" style="color:#666;margin-top: 20px;line-height: 26px;">{{ x.title
                                        }}</div>
                                    <div class="ftext" style="color:#666;margin-top: 30px;line-height: 26px;"><span
                                            style="color: #1e66d1;">● </span><span style="font-weight: bold;" v-if="x.textt">{{ x.textt }}</span> {{ x.text
                                            }}</div>
                                    <div class="ftext" style="color:#666;margin-top: 10px;line-height: 26px;"><span
                                            style="color:#1e66d1;">● </span> <span style="font-weight: bold;" v-if="x.textbt">{{ x.textbt }}</span>{{ x.textb }}</div>
                                    <div class="ftext" style="color:#666;margin-top: 10px;line-height: 26px;"><span
                                            style="color: #1e66d1;">● </span> <span style="font-weight: bold;" v-if="x.textct">{{ x.textct }}</span>{{ x.textc }}</div>
                                    <div v-show="x.textd" class="ftext"
                                        style="color:#666;margin-top: 10px;line-height: 26px;"><span
                                            style="color: #1e66d1;">● </span> <span style="font-weight: bold;" v-if="x.textdt">{{ x.textdt }}</span>{{ x.textd }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="data.infoimg" style="margin-top: 25px;padding-top: 38px; background: #fff;text-align: center;padding-bottom: 25px;">
                    <div>
                        <div style="font-size: 28px;">接入AI客服业务流程</div>
                    </div>
                    <div style="padding: 20px 10px;"><img style="height: auto;width: 100%;" :src="data.infoimg"></img></div>
                </div>
                <div style="margin-top: 25px;background: #fff;padding:25px 20px;padding-bottom: 50px;">
                    <div style="font-size: 28px;margin-left: 5px;text-align: center;">功能展示
                    </div>
                    <div v-for="z in data.infos" style="margin-top: 30px;">
                        <div><img style="height: auto;margin: 0px auto;" :src="z.src"></div>
                        <div v-if="z.srcb" style="display: flex;">
                            <div><img style="height: 100%;" :src="z.srcb"></div>
                            <div><img style="height: 100%;" :src="z.srcc"></div>
                        </div>
                        <div v-if="z.title" class="buttondh"
                            style="margin: 0px auto;width: 100px;height: 32px;line-height: 32px;text-align: center;border-radius: 30px;font-size: 14px;background: #ececec;margin-top: 20px;">
                            {{ z.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
export default {
    data() {
        return {
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            index:0,
            mindex: 'AI知识库',
            menu: [
                {
                    title: 'AI知识库',
                    text: 'AI知识库是企业级智能数据引擎，通过多模态整合与语义分析，将分散的文档、音视频、客户反馈转化为可行动的洞察（如精准维修方案、风险预警、商机挖掘），解决信息孤岛问题，让数据资产从成本负担升级为增长动力源。',
                    itetle: '从碎片到智能',
                    itext: '数据资产的全生命周期激活',
                    img: require('@/assets/AI/imgback.png'),
                    card: [
                        {
                            title: '企业知识资产统一管理',
                            text: '分散在多个系统（CRM/ERP/Confluence）中的产品文档、技术方案、会议纪要等非结构化数据难以整合。',
                            textb: '实时同步多源数据，构建“产品参数-客户案例-故障解决方案”动态知识图谱。',
                            textc: '支持自然语言模糊查询（如“类似A客户的方案”），结果关联度＞90%。'
                        },
                        {
                            title: '合规审计自动化',
                            text: '人工审核海量合同、邮件存在漏检风险（如金融条款违规、医疗数据泄露）。',
                            textb: '嵌入行业合规规则库（金融/医疗/法律），实时扫描文档并标记风险点-客户案例-故障解决方案”动态知识图谱。',
                            textc: '高风险操作自动阻断（如含“保证收益”的理财话术），同步生成合规修正建议。'
                        },
                        {
                            title: '研发知识协同',
                            text: '研发团队分散在多地，技术文档版本混乱，协作效率低。',
                            textb: '自动追踪代码/文档变更，冲突检测后推送关联责任人。',
                            textc: '基于项目需求智能推荐历史方案（如“推荐5个相似模块的测试用例”）。'
                        },
                        {
                            title: '供应链风险预警',
                            text: '供应商交货延迟、原材料价格波动等风险难以及时发现。',
                            textb: '整合采购数据、市场情报、物流记录，生成供应链风险热力图。指数并触发预警。',
                            textc: '自动触发应急策略（如“推荐替代供应商清单”或“安全库存预警”。'
                        }
                    ],
                    infotitle:'功能展示',
                    infos: [{
                        title: '知识库首页',
                        src: require('@/assets/AI/img.png'),
                    },
                    {
                        title: '知识管理',
                        src: require('@/assets/AI/img2.png'),
                        srcb: require('@/assets/AI/img3.png'),
                        srcc: require('@/assets/AI/img4.png'),
                    },
                    {
                        title: '分级管理',
                        src: require('@/assets/AI/img5.png')
                    },
                    {
                        title: '分级管理',
                        src: require('@/assets/AI/img6.png')
                    }]
                },
                {
                    title: 'AI智能客服',
                    text: '基于生成式AI的全渠道对话引擎，理解复杂语义并生成个性化解决方案，支持情绪识别与业务系统联动（如自动生成工单），应用于客户咨询诊断、销售机会挖掘等场景，问题解决率提升至89%。',
                    itetle: '价值对比',
                    itext: '',
                    img: require('@/assets/AI/imgback.png'),
                    card: [
                        {
                            title: '多模态复杂问题处理',
                            text: '客户咨询需同时上传设备故障视频、文字描述和图片，传统客服无法关联分析多类型信息，问题解决周期长达48小时以上。',
                            textbt:'智能解析：',
                            textb: '同步识别视频中的设备异常画面、文字描述的故障代码、图片中的部件状态。',
                            textct:'即时响应：',
                            textc: '自动生成图文版排查指南（含备件更换示意图），并附带维修预约链接。'
                        },
                        {
                            title: '情感化服务调解',
                            text: '客户因投诉处理延迟产生强烈不满，需快速安抚避免升级。',
                            textb: '实时检测语音语调/文字关键词（如“投诉”）/医疗/法律），实时扫描文档并标记风险点-客户案例-故障解决方案”动态知识图谱。',
                            textbt:'情绪雷达：',
                            textc: '普通焦虑可自动发送服务进度通知（“您的订单将于12小时内发货”）；严重冲突则秒转专家坐席并推送客户画像（历史订单+沟通记录）。',
                            textct:'分级应对：',
                        },
                        {
                            title: '长周期客户关系维护',
                            text: '客户历史交互记录分散，重复咨询时需重新描述问题。',
                            textb: '自动关联180天内全渠道交互记录（电话/在线/邮件），主动提示：“您上周咨询的XX问题已有新进展，点击查看详情”。',
                            textbt:'自动追踪代码/记忆强化：',
                            textc: '基于服务周期触发提醒（如“您购买的设备还剩15天保修期”）。',
                            textct:'预见服务：',
                        },
                        {
                            title: '销售机会智能挖掘',
                            text: '客户咨询中隐含比价、扩容等潜在需求，传统客服难以识别。',
                            textb: '识别6类购买信号（比价/扩容/功能缺陷对比），自动标记高意向对话并推送销售部门。',
                            textbt:'深度洞察：',
                            textc: '根据对话内容生成《客户定制方案》（含竞品对比数据）。',
                            textct:'精准打击：',
                        }
                    ],
                    infoimg:require('@/assets/AI/infoimg.png'),
                    infos: [{
                        title: '',
                        src: require('@/assets/AI/imgb.png'),
                    },
                    {
                        title: '',
                        src: require('@/assets/AI/img2b.png'),
                    }]
                },
                {
                    title: 'AI智慧党建',
                    text: 'AI赋能智慧党建，正推动一场从理念到工具、从流程到效能的系统性变革。依托大数据、自然语言处理、知识图谱等前沿技术，AI已深度融入政策解读、公文管理、党员服务等核心环节，成为新时代党建工作的“红色智能助手”，为组织生活注入高效、精准与规范的新动能。',
                    itetle: '从“大海捞针”到“秒抓核心”',
                    itetleb: '从“绞尽脑汁”到“智能创编”',
                    itetlec: '从“层层翻找”到“开口即得”',
                    itext: '',
                    img: require('@/assets/AI/imgback.png'),
                    card: [
                        {
                            tttt: "政策文件解读",
                            title: '“秒级响应+精准加工”重构党建工作的信息处理链条，让政策文件从“大海捞针”到“秒抓核心”的智能化跃迁。',
                            text: '自动识别文件结构，生成可视化目录。',
                            textt:'目录级解析：',
                            textb: '精准抓取关键信息，形成政策要素清单。',
                            textbt:'要素提取：',
                            textc: '自动剔除政策文本中的重复表述、保留可执行性强的刚性要求。',
                            textct:'冗余内容过滤：',
                        },
                        {
                            tttt: "公文生成",
                            title: '覆盖党政材料的专业知识。用户仅需输入关键词或提纲，系统即可自动匹配最新政策表述，生成格式规范、术语准确的初稿，通过AI编辑能力可对初稿进行多维度深度加工。',
                            text: '基于语义分析自动补充背景信息、政策依据或典型案例。',
                            textb: '自动嵌入权威统计数据或本地化案例。',
                            textc: '针对标准化内容，AI提供多版本模板供选择。',
                            textt:'段落扩写：',
                            textbt:'数据增强：',
                            textct:'示例生成：',
                        },
                        {
                            tttt: "校对润色",
                            title: '从基础纠错到智能优化的全面升级，结合政策合规性、语义逻辑、风格适配等维度，显著提升规范性与专业性。',
                            text: '内置规则库，可识别敏感词，自动识别错别字、语法错误、标点误用。',
                            textb: '通过语义分析标记段落断层，建议调整结构权重。',
                            textc: '公文格式标准化，支持导出为PDF文件，直接下发使用。',
                            textt:'智能纠错：',
                            textbt:'智能优化：',
                            textct:'在线排版：',
                        },
                        {
                            tttt: "信息查询",
                            title: '通过自然语言交互和权限智能识别，让党务查询从"菜单点击"转向"对话交流"，实现党建数据的智能问答和精准获取。',
                            text: '通过对话，党支部书记可查询本支部完整会务数据，包括支部党员大会、支部委员会、组织生活会的召开次数等。普通党员仅显示个人参会记录。',
                            textb: '多维统计分析，实时展示党员人数、男女比例、年龄结构、学历分布等关键指标。',
                            textc: '党员个人信息管理、党费缴纳情况、发展党员情况跟踪等信息查询通过AI都可以精准快速的获取。',
                            textt:'会务召开情况查询：',
                            textbt:'党组织基本情况查询：',
                            textct:'以及更多如：',
                        }
                    ],
                    infos: [{
                        title: '政策文件解读',
                        src: require('@/assets/AI/imgc.png'),
                    },
                    {
                        title: '公文生成',
                        src: require('@/assets/AI/img2c.png'),
                    },
                    {
                        title: '校对润色',
                        src: require('@/assets/AI/img3c.png')
                    },
                    {
                        title: '信息查询',
                        src: require('@/assets/AI/img4c.png')
                    }]
                },
                {
                    title: 'AI信息安全',
                    text: '在数字化转型的浪潮中，信息安全已成为企业稳健发展的核心命脉，我们推出“企微轻量化应用AI赋能信息安全”，以创新AI技术重塑安全信息管理。这不仅是一次技术升级，更是一场效率革命。想象一下，您的企业能实时掌控安全风险，自动生成精准报告，并在故障发生时智能响应——这一切，都通过AI大模型的深度集成变为现实。现在，让我们深入探索AI如何为您的信息安全保驾护航。',
                    itetle: '从“人工汇编”到“智能排查”',
                    itext: 'AI技术重塑安全信息管理',
                    img: require('@/assets/AI/imgback.png'),
                    card: [
                        {
                            tttt: "信息安全月报",
                            title: '智能日志聚合与威胁分析：从“数据噪音”到“精准洞察”。',
                            text: '防火IDS、终端行为等异构日志自动采集，通过NLP解析关键字段（如IP、协议、事件类型）。',
                            textb: '机器学习聚类算法压缩97%无效告警，误报率从传统30%降至5%以内。',
                            textc: 'NLP自动提炼千条日志为结构化报告，涵盖攻击类型分布、根因分析、处置效果。',
                            textd: '动态图表展示风险热力图、漏洞修复进度、合规达标率。',
                            textt:'AI 自动采集：',
                            textbt:'降噪压缩：',
                            textct:'月报/总结：',
                            textdt:'可视化看板：',
                        },
                        {
                            tttt: "RPA机器人",
                            title: '通过RPA机器人将网络日志、算力日志和安全日志导出到固定目录，AI大模型会实时分析这些日志，精准识别高危、中危、低危等风险字段，输出结构化报告，这不仅节省了90%的人工时间，还确保了数据的零误差。',
                            text: 'RPA机器人将网络设备、服务器及安全系统自动采集异构日志。支持定时触发或事件驱动（如磁盘空间不足自动触发导出），实现7 * 24小时无人值守运行。',
                            textb: '自动清洗重复/无效数据，提取关键字段（时间戳、事件类型、源IP等）并转换为统一格式（CSV/JSON）。',
                            textc: '按预设目录层级存储（如/logs/网络/20250716_access.log），为AI分析提供高质量输入。'
                        },
                        {
                            tttt: "故障报修",
                            title: '基于AI大模型驱动的智能故障报修系统，正在彻底重构传统设备维护流程的核心范式。通过融合深度学习、自然语言处理、知识图谱与自动化引擎，系统实现了从故障感知到闭环修复的全链路智能化升级。',
                            text: '系统预先整合设备手册、故障案例库、维修方案等文档至大模型知识库；用户提交报修时，AI实时解析故障描述（如“投影仪无法开机”），自动匹配历史案例与解决方案（如“电源模块故障概率78%，建议检查电源线连接”）。',
                            textb: '用户选择“解决”，流程自动终止，生成解决记录并同步知识库（如新增“电源线松动”解决方案）；用户选择“未解决”，自动生成结构化工单（含故障描述、AI建议、用户反馈），分配至维修人员队列。',
                            textc: '管理员可查看多维数据：工单积压量、平均解决时长、AI拦截率、设备故障热力图；服务等级协议达标情况实时预警（如“核心系统工单超时率＞5%”触发告警）。',
                            textt:'AI自助预诊断与智能建议生成：',
                            textbt:'双路径闭环处理：',
                            textct:'实时监控看板：',
                        },
                        {
                            tttt: "知识图谱",
                            title: '通过整合网络设备日志、威胁情报、漏洞库、故障保修等多源异构数据，构建动态知识图谱网络，实现高效威胁识别与攻击链还原。',
                            text: '关联漏洞、威胁情报、用户行为等实体，量化风险等级并预判影响范围。',
                            textb: '融合资产拓扑、漏洞、威胁情报图谱，动态生成攻击面热力图，辅助资源调配。',
                            textc: '根据攻击模式匹配防御知识库，自动生成阻断规则或修复建议。'
                        }
                    ],
                    infos: [{
                        title: '',
                        src: require('@/assets/AI/imgd.png'),
                    },
                    {
                        title: '',
                        src: require('@/assets/AI/img2d.png'),
                    }]
                },
                {
                    title: 'AI舆情监测',
                    text: '在信息爆炸的时代，企业内部沟通蕴含着海量“声音”——客户反馈、员工情绪、市场动态、潜在风险与机遇。AI赋能的企业微信会话存档实时舆情分析功能，正是开启这座信息金矿、实现智慧决策的关键钥匙。',
                    itetle: '洞察先机，智驭舆情',
                    itext: 'AI+企业微信会话存档实时舆情分析',
                    img: require('@/assets/AI/imgback.png'),
                    card: [
                        {
                            tttt: '客户服务',
                            title: '基于企业微信会话存档与AI技术的结合，客户服务正从被动响应升级为预测性、个性化、自动化的智能运营体系。',
                            text: '通过NLP情感分析模型实时扫描全渠道会话，智能识别包含“投诉”“退款”“欺诈”等高危词汇的对话，结合上下文判断情感倾向（负面/紧急）。',
                            textb: '多模态融合分析（文本+图片OCR+语音转译），例如识别客户发送的发票图片中的投诉内容。',
                            textc: '5分钟内推送预警至客服主管，拦截60%的客诉升级风险。'
                        },
                        {
                            tttt: '合规风控',
                            title: '基于企业微信生态的AI会话存档系统，正通过“技术+规则+流程”重构合规风控体系。',
                            text: '预设金融、医疗等不同行业的合规关键词库（如“返佣” “个人微信”），结合知识图谱识别违规链路（如“删除客户→添加私人账号→转账”）。',
                            textb: '实时关联图谱分析（Neo4j图数据库）+ 语义消歧，避免误判。',
                            textc: '整合司法、税务、舆情等各类数据源（如裁判文书、行政处罚），动态评估企业合作方风险。'
                        },
                        {
                            tttt: '销售赋能',
                            title: 'AI结合企业微信会话存档技术，正通过多维度能力重构销售工作流程，将海量沟通数据转化为可执行的销售策略和实时辅助工具。',
                            text: '分析会话中隐含需求（如“预算多少”“竞品对比”），自动推送产品方案库话术，提示销售跟进。',
                            textb: '自动整合历史沟通记录（如产品咨询频次、预算提及率），构建包含需求紧急度、决策偏好等维度的客户画像。',
                            textc: 'AI话术实时推荐：根据客户当前问题（如“产品A和B的区别”），自动生成适配话术并推送至企业微信侧边栏，减少员工手动检索时间。',
                            textd: '敏感词（如“价格”“优惠”）触发自动打标签，并联动客户运营SOP（例：打标“高意向”后推送优惠话术模板）。'
                        },
                        {
                            tttt: '员工情绪',
                            title: '基于AI技术结合企业微信等平台的会话内容存档，员工情绪监测已从传统的抽样调查升级为实时、精准、多模态的智能分析系统。',
                            text: '分析内部沟通工具（如企业微信）中的文本情感（如“加班”“离职”提及频次），按部门/项目生成情绪健康指数。',
                            textb: '分析员工协作会话中的情绪互动模式，优化考核机制（如销售团队取消“末位淘汰制”后积极情绪上升25%）。',
                            textc: 'AI识别高压力员工，推送EAP心理咨询入口，保障隐私前提下提供支持。'
                        }
                    ],
                    infos: [{
                        title: '',
                        src: require('@/assets/AI/imge.png'),
                    },
                    {
                        title: '',
                        src: require('@/assets/AI/img2e.png')
                    },
                    {
                        title: '',
                        src: require('@/assets/AI/img3e.png')
                    }]
                }
            ],
            data: {},
            height: 'calc(100vh - 80px)',

        }
    },
    created() {
        var w = window.innerWidth
        var h = window.innerHeight * 0.18 + window.innerHeight - 80
        if (w < 1550) {
            this.height = h + 'px'
        }
        this.load()
    },
    activated() {
        this.load()
    },
    methods: {
        load() {
            var title = this.$route.query.title||this.$route.query.id
            if(title){
                this.menu.forEach(x=>{
                    if(x.title == title){
                        this.getInfo(x)
                    }
                })
            }else{
                this.getInfo(this.menu[0],0)
            }
        },
        getInfo(w,j) {
            this.index = j
            this.mindex = w.title
            this.data = w
            // this.$http('/Product/GetData', { typeid: x.ID }).then(x => {
            //     if (x.length > 0)
            //         this.data = x[0]
            //     else this.data = {}
            //     var asd = document.getElementById("productscrollb")
            //     window.scrollTo({
            //         top: 0,
            //         behavior: 'smooth' // 平滑滚动
            //     });
            //     asd.scrollTo({
            //         top: 0,
            //         behavior: 'smooth' // 平滑滚动
            //     });
            // })
        }
    }
}
</script>
<style scoped>
.mindex {
    background: #1e66d1;
    color: #fff;
}

.menu:hover {
    background: #f5f5f5;
    color: #1e66d1;
}

table {
    border: 1px solid #e4e6e8;
    border-right: 1px solid #e4e6e8;
    border-bottom: 1px solid #e4e6e8;
}

td {
    border-left: 1px solid #e4e6e8;
    border-top: 1px solid #e4e6e8;
    width: 20%;
    height: 40px;
    padding: 5px 10px;
    font-size: 13px;
    font-weight: bold;
}

#productscroll::-webkit-scrollbar {
    width: 0px;
}

#productscrollb::-webkit-scrollbar {
    /* width: 0px; */
}
</style>